import React, { useEffect, useState } from "react"
import RedBarFullSize from "./FullSize";
import RedBarMini from "./Mini";

const BREAKPOINT = 1080

export default function RedBar(props) {
  // React to viewport resize so the right variant renders if a user
  // resizes their window or rotates their device — previously this was
  // measured once at mount via useRef and stayed stuck.
  const [showMinimized, setShowMinimized] = useState(
    typeof window !== "undefined" ? window.innerWidth < BREAKPOINT : false
  )

  useEffect(() => {
    if (typeof window === "undefined") return
    const onResize = () => setShowMinimized(window.innerWidth < BREAKPOINT)
    window.addEventListener("resize", onResize)
    return () => window.removeEventListener("resize", onResize)
  }, [])

  return showMinimized
    ? <RedBarMini  {...props} />
    : <RedBarFullSize  {...props} />
}